'use client';

import { usePathname } from 'next/navigation';
import Image from 'next/image';
import notFoundIcon from '@images/ico_404.webp';
import { TrackedAnchor } from '@/components/ancher';

export default function NotFound() {
  const pathname = usePathname();

  // pathname에서 locale 추출 및 설정
  const locale = pathname.startsWith('/ko') ? 'ko' : 'en';

  const content = {
    ko: {
      title: '페이지를 찾을 수 없습니다.',
      message1:
        '페이지의 주소를 잘못 입력하였거나, 요청하신 페이지를 찾을 수 없습니다.',
      message2: '아래 버튼을 눌러 메인으로 이동하세요.',
      buttonLabel: '메인으로 가기',
    },
    en: {
      title: "Oops! You're lost.",
      message1: "We can't find the page you're looking for.",
      message2: 'Go back to the homepage or double-check the URL.',
      buttonLabel: 'Go to Home',
    },
  };

  return (
    <div className="flex flex-col items-center justify-center gap-6 pb-[100px] pt-[200px] text-center lg:pb-[150px] lg:pt-[250px]">
      <Image src={notFoundIcon} alt="404 Icon" width={100} height={100} />
      <div className="flex flex-col items-center justify-center gap-3">
        <h1 className="text-h6 font-semibold text-3b-text-primary lg:text-h4">
          {content[locale].title}
        </h1>
        <p className="max-w-[350px] text-body2 font-medium text-3b-text-secondary md:flex md:max-w-[450px] md:flex-col lg:text-sh2">
          <span className="mr-1 md:mr-0">{content[locale].message1}</span>
          <span>{content[locale].message2}</span>
        </p>
      </div>
      <TrackedAnchor
        label="back-to-home"
        position="main_content"
        href={`/`}
        className="block rounded-[30px] bg-3b-background-medium px-4 py-2 text-sh1 font-semibold text-3b-text-primary lg:rounded-[40px] lg:px-6 lg:py-3"
      >
        <span className="text-sh2 font-semibold text-3b-text-primary">
          {content[locale].buttonLabel}
        </span>
      </TrackedAnchor>
    </div>
  );
}
